module.exports = __webpack_public_path__ + "/static/assets/8b8f2d052b4092ec47ad66c30c8b1642.svg";